module.exports = __webpack_public_path__ + "static/media/TurkeyRoost.svg";